import {MovieService, PageService, AuthService, OrderService} from 'hasta-la-vista-middleware-api/service'
import Vue from 'vue'
import MetaData from  '../../../mixins/meta-data.js'

export default {
    name: 'subs-club',

    mixins: [MetaData],

    data(){
        return {
          cinema_type: "standalone",
          items: [],
          loading: true,
          selectedItem: null,
          lsItem: null,
          user: null,
          guest: true,
        }
    },

    methods: {
        getConcessionItems(concessionItems) {
            var items = []
            for(var k = 0; k < concessionItems.length; k++) {
                var item = concessionItems[k]
                item.Price = "R " + (concessionItems[k].PriceInCents / 100)
                item.Quantity = 1
                items[k] = item
            }

            return items
        },

        setSubsOption(itemId) {
            for(var i in this.items) {
                // console.log(this.items[i]);

                if(this.items[i].Id == itemId) {
                    this.selectedItem = this.items[i]
                    let nextStep = "requires-auth"
                    let nextUrl = "/user/login"
                    if(!this.user.isGuest()) {
                        nextStep = "confirm-details"
                        nextUrl = "/subscribe/1"
                    }

                    this.lsItem = {
                        'item': this.selectedItem,
                        'progress': {'currentStep': 0, 'currentStepName': "select-option", "currentStepUrl": "/subscription-club", 'nextStep': 1, "nextStepName": nextStep, "nextStepUrl": nextUrl}
                    }
                    window.localStorage.setItem('subsClub', JSON.stringify(this.lsItem));

                    this.$router.push(nextUrl)
                }
            }
        },

        setUser(){
            AuthService.user().then((user)=> {
                this.user = user;
                this.guest = user.isGuest();
                if (!user.isGuest() && user.MembershipActivated === false && this.first_time) {
                    // this.cookieActive = false;
                    // this.first_time = false;
                } else {
                    // this.showUserActivation = false;
                }
            })
        },
    },

    created(){
        this.metaTitle = 'SK Subscription Club'
        this.loading = true
        Promise.all([OrderService.getConsessionsByCinemaId(this.cinema_type), this.setUser()]).then(([concessions, user]) => {
                window.localStorage.removeItem('subsClub');
                for(var i = 0; i < concessions.length; i++) {
                    if(concessions[i].Name == "Subs") {
                        this.items = this.getConcessionItems(concessions[i].ConcessionItems);
                    }
                }
                this.loading = false
                // console.log(this.items)
            }, (error) => {
                Promise.reject(error)
            }
        );
    },

    mounted() {
        window.scroll({top: 0, left: 0})
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/subs-club/subs-club.js